import { createDataReducer } from 'app/api/redux-jigsaw/userdata/utils/reducer-utils';
import {
  ADD_NOTE,
  DELETE_NOTE,
  GET_NOTES,
  UPDATE_NOTE,
} from 'app/api/redux-jigsaw/jigsaw-methods';

export default createDataReducer({
  get: GET_NOTES,
  add: ADD_NOTE,
  del: DELETE_NOTE,
  update: UPDATE_NOTE,
  itemName: 'note',
  listName: 'notes',
});
